export default __webpack_public_path__ + "static/media/707.eaaf30b6.jpg";